import type { IWithdrawalCoin } from "@/store/apis/withdrawalAPI"
import { DisconnectWalletModal } from "./DisconnectWalletModal"
import { WithdrawOtpModal } from "./WithdrawOtpModal"

export const WALLET_MODALS = {
  disconnectWallet: {
    component: DisconnectWalletModal
  },
  withdrawOtp: {
    component: WithdrawOtpModal,
    params: {} as {
      coin: IWithdrawalCoin
      amount: number
      onSuccess: () => void
    }
  }
} as const
